/*
GPS DataViz

Copyright © 2021 GPSDataViz

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

import React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Table } from "antd";
import "../../Styles/styles-ResultsTable.css";
import "../../Styles/styles-Example.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useSelector } from "react-redux";


export function ComparisonChart({ dataIn, teamColors, home_page }) {

  const {
    comparisonCharts
  } = useSelector(({ compare }) => compare);

  let num_games_compared = dataIn.num_games;

  let arr = Array.from({ length: num_games_compared }, (_, i) => i);

  let colors = teamColors.all;


  let tables = {};
  let tableHeaderColumns = [];
  for (let i = 0; i < dataIn.metrics.length; i++) {
    let metric = dataIn.metrics[i];
    let key = metric.key;
    let tableDataList = [];
    let tableDataObj = {};
    let tableHeaderColumn = {};
    for (let j = 0; j < dataIn.data.length; j++) {
      tableDataObj = {};
      for (let k = 0; k < arr.length; k++) {
        let opponent_name = dataIn.data[j][k + "_opponent_name"];
        if (opponent_name === undefined) continue;
        let opponent_name_key = opponent_name?.replace(/\s+/g, '_')?.toLowerCase();
        if (i === 0 && j === 0 ) {
          tableHeaderColumn["title"] = opponent_name;
          tableHeaderColumn["dataIndex"] = opponent_name_key; 
          tableHeaderColumn["key"] = opponent_name_key;
          tableHeaderColumn["onHeaderCell"] = () => {
            return {
              style: {
                backgroundColor: colors[k], 
                color: '#fff'
              }
            };
          };
          tableHeaderColumns.push(tableHeaderColumn);
          tableHeaderColumn = {};
        }
        let dataKey = k + "_" + key + "__avg";
        if (dataIn.data[j][dataKey] === null || dataIn.data[j][dataKey] === undefined || dataIn.data[j][dataKey] === 0) continue;
        tableDataObj[opponent_name_key] = `${dataIn.data[j][dataKey]} - ${dataIn.data[j][dataKey + "_name"].split(" ")[1]}`;
      }
      if (Object.keys(tableDataObj).length > 0) tableDataList.push(tableDataObj);
    }
    if (tableDataList.length > 0) tables[key] = tableDataList;
  }

  return (
    <>
      <div>
        {comparisonCharts && comparisonCharts.map(chart => 
          <div className="day-compare-chart-and-table">
            <h3> {chart.name} </h3>
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-evenly',
              marginBottom: '5rem',
              height: '430px'
            }}>
              <HighchartsReact highcharts={Highcharts}             
                options={{
                  ...chart.data,
                  chart: {
                    ...chart.data?.chart,
                    height: '430px' 
                  }
                }}
              />
              <Table
                rowKey="Id"
                columns={
                  tableHeaderColumns
                }
                size="small"
                dataSource={tables[chart.key]}
                className="exportable gpsdv-table compare-table"
                rowClassName={"ant-table-row-no-shadow"}
                pagination={false}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}
